<div class="dialogs-container">
  <aside class="senders-sidebar">
    <app-scrollbar
      [vertical]="true"
      size="standard"
      visibility="native"
      class="scrollbar scrollbar-senders">
      @for (sender of senders; track sender) {
        <div
          class="sender-item"
          [class.sender-item--active]="sender.id === selectedSenderId"
          [class.disabled]="!sender.isAccessible"
          (click)="selectSender(sender)">
          <div class="sender-item__avatar">
            @if (sender.avatar) {
              <img alt="Sender Avatar" class="sender-item__avatar-img" [src]="sender.avatar" />
            } @else {
              <svg class="icon">
                <use xlink:href="#user-icon"></use>
              </svg>
            }
            <app-account-status class="status" [accountState]="sender.status"></app-account-status>
          </div>
          <span class="sender-item__name">{{ sender.name }}</span>
        </div>
      }
    </app-scrollbar>
  </aside>

  @if (recipientInfo) {
    <main class="messages-area">
      <header class="messages-header">
        <div class="recipient-info">
          <div class="recipient__avatar">
            @if (recipientInfo.avatar) {
              <img
                alt="Recipient Avatar"
                class="recipient__avatar-img"
                [src]="recipientInfo.avatar" />
            } @else {
              <svg class="icon">
                <use xlink:href="#user-icon"></use>
              </svg>
            }
          </div>
          <h4 class="recipient__name">{{ recipientInfo.name }}</h4>
        </div>
        @if (messageState === 'not-connected') {
          <button
            class="btn btn--filled btn-small"
            [class.disabled]="isProfileConnecting"
            (click)="connectProfile()">
            <svg class="icon btn__icon" width="16" height="16">
              <use xlink:href="#plus-bold"></use>
            </svg>
            <span class="btn__text">{{ 'MESSAGES.MODAL.CONNECT' | translate }}</span>
          </button>
        }
      </header>
      @if (
        (messageState === 'loaded' && messages && messages.length > 0) || messageState !== 'loaded'
      ) {
        <app-scrollbar
          [vertical]="true"
          [horizontal]="false"
          size="standard"
          visibility="native"
          class="scrollbar scrollbar-messages">
          @if (messageState === 'loaded' && messages && messages.length > 0) {
            <div class="messages-list" [appScrollToBottom]="messages">
              @for (message of messages; track message) {
                @if (message.isDaySeparator) {
                  <div class="message-day-separator">
                    <span class="message-day-separator__text">{{ message.content }}</span>
                  </div>
                } @else {
                  <div
                    class="message"
                    [class.message--received]="!message.isSent"
                    [class.message--sent]="message.isSent">
                    <div class="message__bubble">
                      <div class="message__content">{{ message.content }}</div>
                      <div class="message__timestamp">{{ message.timestamp }}</div>
                    </div>
                  </div>
                }
              }
            </div>
          }
          <!-- Empty state content -->
          @if (messageState !== 'loaded') {
            <div
              class="empty-state"
              [class.empty-state--error]="messageState === 'error'"
              [class.empty-state--no-connection]="messageState === 'not-connected'">
              <div class="empty-state__content">
                @if (messageState === 'error') {
                  <svg class="icon">
                    <use xlink:href="#error-outlined-circle"></use>
                  </svg>
                }
                @if (messageState === 'not-connected') {
                  <svg class="icon">
                    <use xlink:href="#arrow"></use>
                  </svg>
                }
                @if (messageState === 'loading') {
                  <p>{{ 'MESSAGES.MODAL.EMPTY_STATE.LOADING' | translate }}</p>
                }
                @if (messageState === 'no-messages') {
                  <p>{{ 'MESSAGES.MODAL.EMPTY_STATE.NO_MESSAGES' | translate }}</p>
                }
                @if (messageState === 'not-connected') {
                  <p>{{ 'MESSAGES.MODAL.EMPTY_STATE.NOT_CONNECTED' | translate }}</p>
                }
                @if (messageState === 'sent-connection') {
                  <p>{{ 'MESSAGES.MODAL.EMPTY_STATE.SENT_CONNECTION' | translate }}</p>
                }
                @if (messageState === 'error') {
                  <p>{{ 'MESSAGES.MODAL.EMPTY_STATE.ERROR' | translate }}</p>
                }
              </div>
            </div>
          }
        </app-scrollbar>
      }
      @if (messageState === 'loaded' || messageState === 'no-messages') {
        <footer class="message-input-footer">
          <div class="message-input-container">
            <textarea
              class="message-input"
              [placeholder]="'MESSAGES.MODAL.SEND_MSG_PLACEHOLDER' | translate"
              [(ngModel)]="messageText"
              (keyup.enter)="sendMessage()"></textarea>
            <button class="btn btn--filled" (click)="sendMessage()">
              <span class="btn__text">Send</span>
            </button>
          </div>
        </footer>
      }
    </main>
  }
</div>
